import { memo, useCallback } from "react";
import { Image } from "react-bootstrap";
import ScheduleIcon from "../../../Img/pickup-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { setPatientEdit } from "redux/reducers/SearchPanel/globalSearch.slice";
import { sendDataToSocket } from "socket/SocketComponent";
import {
  getPermissionLocationWise,
  setSelectedLocation,
} from "redux/reducers/Role/role.slice";
import { Button } from "antd";
import EditIcon from "../../../Img/edit-icon.svg";
import moment from "moment";
import {
  getReminderData,
  setIsEditReminderModal,
  setShowReminderModal,
} from "redux/reducers/Dashboard/dashboard.slice";

const ScheduleList = () => {
  const { scheduleObject, scheduleLoader, isEditReminderModal } = useSelector(
    ({ dashboard }) => dashboard
  );
  const { selectedLocation } = useSelector(({ role }) => role);
  const dispatch = useDispatch();

  const handleEditReminder = useCallback(
    (e, id) => {
      e.preventDefault();
      dispatch(setShowReminderModal(true));
      dispatch(setIsEditReminderModal(id));
      dispatch(getReminderData({ location_id: selectedLocation, id }));
    },
    [dispatch, selectedLocation]
  );

  let UserPreferences = localStorage.getItem("UserPreferences");
  if (UserPreferences) {
    UserPreferences = JSON.parse(window.atob(UserPreferences));
  }
  if (scheduleLoader) {
    return (
      <div className="schedule_loading">
        <p>Loading...</p>
      </div>
    );
  }
  const openPatient = (record) => {
    dispatch(setPatientEdit(record));
    localStorage.setItem(
      "userLocation",
      window.btoa(JSON.stringify(record.location_id))
    );
    sendDataToSocket("JUR", {
      room_id: record.location_id,
    });
    dispatch(setSelectedLocation(record.location_id));
    dispatch(getPermissionLocationWise(record.location_id));
  };

  const getInitialLetter = (value) => {
    if (!value || typeof value !== "string" || value.trim() === "") return "UN";
    return value.charAt(0).toUpperCase();
  };

  return (
    <>
      {scheduleObject?.scheduleList?.length ? (
        <>
          {scheduleObject?.scheduleList?.map((item) => {
            const {
              _id,
              reminder_date,
              pick_up_time,
              activity,
              location_name,
              patient_full_name,
              title,
            } = item;
            const isDisabledEditReminder = isEditReminderModal === _id;
            const openPatientData = { ...item, _id: item.patient_reg_id };

            return (
              <div className="user_information d-flex justify-content-between align-content-center">
                <div
                  className="user_information_partioton"
                  onClick={() =>
                    patient_full_name && openPatient(openPatientData)
                  }
                >
                  <div className="d-flex">
                    <div className="user_logo d-flex justify-content-between align-items-center">
                      <div className="user_logo_image">
                        <div className="user_img">
                          <div className="user_name_letter">
                            {getInitialLetter(patient_full_name || title)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="user_description">
                      <p className="m-0 user_name">
                        {patient_full_name || title}
                        {!UserPreferences?.other && location_name
                          ? ` - ${location_name}`
                          : ""}
                      </p>
                      <div className="pickup_time d-flex align-items-center">
                        <div className="pickup_time_icon">
                          <Image
                            src={ScheduleIcon}
                            alt=""
                            className="h-100 w-100 object-fit-cover"
                          />
                        </div>
                        <p className="m-0 user_pickup_time">
                          {reminder_date ? "Reminder" : activity}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user_time d-flex align-items-end flex-column">
                  {!!reminder_date && (
                    <Button
                      className="edit_icon bg-transparent border-0 p-0"
                      onClick={(e) => handleEditReminder(e, _id)}
                      disabled={isDisabledEditReminder}
                    >
                      <img src={EditIcon} alt="" />
                    </Button>
                  )}
                  <p className="m-0">
                    {reminder_date
                      ? moment(reminder_date).format("HH:mm:ss")
                      : pick_up_time}
                  </p>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          <div className="data-found d-flex align-items-center justify-content-center">
            <div className="no-data-fount">
              <h3>No data found</h3>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default memo(ScheduleList);
